import * as React from "react";
import { TransformGroup } from "./TransformGroup";

export const Spinner = () => (
    <TransformGroup rotation="spinner">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.51927 2.10096C5.68519 2.3878 5.58717 2.75484 5.30034 2.92076C3.68471 3.85535 2.5999 5.6007 2.5999 7.59871C2.5999 10.581 5.01756 12.9987 7.9999 12.9987C10.9822 12.9987 13.3999 10.581 13.3999 7.59871C13.3999 5.6007 12.3151 3.85535 10.6995 2.92076C10.4126 2.75484 10.3146 2.3878 10.4805 2.10096C10.6465 1.81413 11.0135 1.71611 11.3003 1.88204C13.2715 3.0223 14.5999 5.15502 14.5999 7.59871C14.5999 11.2438 11.645 14.1987 7.9999 14.1987C4.35482 14.1987 1.3999 11.2438 1.3999 7.59871C1.3999 5.15502 2.72829 3.0223 4.69947 1.88204C4.9863 1.71611 5.35334 1.81413 5.51927 2.10096Z"
        />
    </TransformGroup>
);
